
// ══════════════════════════════════════════════════════════════════
// EN — reemplaza tu export const booking en el archivo de inglés
// ══════════════════════════════════════════════════════════════════
export const booking = {
  createBooking: "Crea prenotazione",
  detailsTitle: "Dettagli della prenotazione",
  createdOn: "creata il",
  statusBooked: "Prenotata",
  processing: "Elaborazione...",
  reject: "Rifiuta",
  cancelled: "Prenotazione annullata",
  guests: "Ospiti",
  nights: "Notti",

  responsibleTitle: "Responsabile della prenotazione",
  name: "Nome",
  email: "Email",
  emailNotProvided: "Nessuna email fornita",
  phone: "Telefono",
  phoneNotProvided: "Nessun telefono fornito",
  replyWhatsapp: "Rispondi su WhatsApp",
  notes: "Nota",
  notesEmpty: "Nessuna nota",
  notesPlaceholder: "Note interne della prenotazione (es. arrivo tardivo, culla, allergie…)",
  notesEdit: "Modifica nota",
  notesSave: "Salva",
  notesCancel: "Annulla",
  notesSaved: "Nota aggiornata",
  notesSaveError: "Impossibile salvare la nota",

  amountTitle: "Importo della prenotazione",

  // Menu buttons & states
  validatingLink: "Convalida del link...",
  sendPaymentLink: "Invia link di pagamento",
  copyPaymentLink: "Copia link di pagamento",
  sendingPaymentLink: "Invio del link di pagamento…",
  whatsappSent: "Link di pagamento inviato via WhatsApp.",
  whatsappSentFallback: "Invio del template non riuscito. WhatsApp aperto manualmente.",
  freeReservationInfo: "Prenotazione gratuita - Nessun pagamento richiesto",
  stripeNotConfigured: "Stripe non configurato",
  changePaymentStatus: "Cambia stato del pagamento",

  // Amount status
  amountStatus: "Stato dell'importo",
  paymentPending: "Pagamento in sospeso",
  paid: "Pagato",
  rejected: "Rifiutato",
  refunded: "Rimborsato",
  partial: "Pagamento parziale",

  // Totals
  subtotal: "Subtotale:",
  totalDiscounts: "Totale sconti:",
  totalTaxes: "Totale imposte:",
  total: "Totale:",

  // Payment status modal
  changePaymentStatusHeader: "Cambia stato del pagamento",
  paymentStatusLabel: "Stato del pagamento",
  select: "Seleziona",
  pending: "In sospeso",
  paidShort: "Pagato",
  close: "Chiudi",
  saveChanges: "Salva modifiche",

  // Toastr / Messages
  paymentUrlSuccess: "URL di pagamento generato con successo",
  paymentUrlError: "Errore durante la generazione dell'URL di pagamento",

  linkGenerated: "Link di pagamento generato con successo",
  linkRegenerated: "Link di pagamento aggiornato a causa di variazioni di prezzo",
  linkPriceZero: "Impossibile generare un link di pagamento per prenotazioni gratuite ($0)",
  linkNoStripe: "L'utente non ha configurato Stripe per ricevere pagamenti",
  linkNoProvider: "Nessun provider di pagamento configurato (Stripe o Wompi)",  // ✅ NUEVA
  linkValidationFailed: "Impossibile generare il link di pagamento. Mancano dati obbligatori.",
  linkValidateError: "Errore durante la convalida del link di pagamento",
  linkValid: "Il link di pagamento è valido",

  copySuccess: "Link copiato con successo",
  copied: "Copiato!",
  copyError: "Si è verificato un errore durante la copia del link",
  error: "Errore",
  statusUpdatedSuccess: "Stato aggiornato con successo",
  statusUpdatedError: "Errore durante l'aggiornamento dello stato del pagamento",  // ✅ NUEVA

  // WhatsApp
  whatsappPayMessage: "Ciao {name}! Ecco il link per pagare la tua prenotazione: {url}",

  checkinsOf: "Check-in di questa prenotazione ({done} di {total})",
  completed: "Completati",
  pendings: "In sospeso",
  date: "Data",
  noCheckinsYet: "Gli ospiti di questa prenotazione non hanno ancora completato il check-in",

  alojamiento: "Alloggio",
};
